// Endpoint specs:
// https://www.dropbox.com/scl/fi/31nxogj0nap0jy842z4sg/Payment-Page.paper?dl=0&rlkey=sx4z963m428xpb3tpar5sb92y#:uid=590688949377277949578901&h2=Endpoint:-initial-data-for-pay

export const mockNewPaymentResponse = {
  isApp: false,
  success: true,
  userID: 11167815,
  paymentMethod: {
    ID: 1234,
    paymentType: "card",
    cardType: "mastercard",
    nickname: null,
    last4: "4532",
    expirationMonth: 4,
    expirationYear: 2023,
    hasOtherOwner: false,
    owner: {},
    isDefaultPaymentMethod: true,
    isEnabledForTTG: false,
    sharedWithOtherHoH: false,
    isSaved: false,
  },
};
